import { MedlemskapTypeId } from '../../MedlemskapType/MedlemskapTypeId';
import { TXT_ENKELTMEDLEMSKAP_DESCRIPTION } from '../../constants';

export const getMedlemskapstypeNamesAndDescriptions = (
    code: string
): { name: string; description: string; summaryTitle: string } | null => {
    switch (code) {
        case MedlemskapTypeId.Enkelt:
            return {
                name: 'Enkeltmedlemskap',
                description: TXT_ENKELTMEDLEMSKAP_DESCRIPTION,
                summaryTitle: 'Medlemskap voksen',
            };
        case MedlemskapTypeId.EnkeltBarn:
            return {
                name: 'Enkeltmedlemskap',
                description: TXT_ENKELTMEDLEMSKAP_DESCRIPTION,
                summaryTitle: 'Medlemskap barn',
            };
        case MedlemskapTypeId.EnkeltUngVoksen:
            return {
                name: 'Enkeltmedlemskap',
                description: TXT_ENKELTMEDLEMSKAP_DESCRIPTION,
                summaryTitle: 'Medlemskap ung voksen',
            };
        case MedlemskapTypeId.EnkeltSenior:
            return {
                name: 'Enkeltmedlemskap',
                description: TXT_ENKELTMEDLEMSKAP_DESCRIPTION,
                summaryTitle: 'Medlemskap senior',
            };
        case MedlemskapTypeId.Familie:
            return {
                name: 'Familiemedlemskap',
                description:
                    'Medlemskap for opp til to voksne og et ubestemt antall barn under 26 år i samme husstand.',
                summaryTitle: 'Medlemskap familie',
            };
        case MedlemskapTypeId.Husstand:
            return {
                name: 'Husstandsmedlem',
                description: 'For deg som bor i samme husstand som et medlem i Skiforeningen.',
                summaryTitle: 'Medlemskap husstand',
            };
        case MedlemskapTypeId.HusstandBarn:
            return {
                name: 'Husstandsmedlem',
                description: 'For deg som bor i samme husstand som et medlem i Skiforeningen.',
                summaryTitle: 'Medlemskap husstand',
            };
        case MedlemskapTypeId.Livsvarig:
            return {
                name: 'Livsvarig medlemskap',
                description:
                    'Som livsvarig medlem i Skiforeningen betaler du en engangssum som tilsvarer 20 ganger årskontingent.',
                summaryTitle: 'Medlemskap livsvarig',
            };
        default:
            return null;
    }
};
